import { Form, Data, FormField, ModalId, useUIActions, FieldType, FieldValue, O } from "../../../../ui"
import { useState } from "react"
import { validatePhone } from "../../../utils/validationsUtils"

type Props = {
    data?: Data
    onSubmit: (phone: number) => void
}

export const PhoneForm = (props: Props) => {
    const { data, onSubmit } = props
    const createMode = !data
    
    const [phone, setPhone] = useState<O<number>>((data?.phone as O<number>))

    const { closeModal } = useUIActions()
    
    const onChangePhone = (value?: FieldValue) => setPhone(value as O<number>)

    const fields: FormField[] = [
        {
            name: 'phone',
            type: FieldType.NUMBER,
            defaultValue: phone,
            label: 'Teléfono',
            validate: validatePhone,
            onChange: onChangePhone
        }
    ]

    const handleSubmit = () => {
        onSubmit(phone!)
        closeModal(ModalId.PHONE_FORM)
    }

    const handleCancel = () => closeModal(ModalId.PHONE_FORM)

    return (
        <Form
            formId="phone-form"
            fields={fields}
            createMode={createMode}
            createLabel="Agregar"
            onSubmit={handleSubmit}
            onCancel={handleCancel}
        />
    )
}
